import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { formatApiError } from "@/lib/api";
import { OHC_LOGO } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#312E81] p-6 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#4F46E5]/30 blur-3xl" />
      <div className="absolute bottom-0 -left-20 w-80 h-80 rounded-full bg-blue-400/10 blur-3xl" />
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8" data-testid="login-card">
        <div className="flex justify-center mb-6"><img src={OHC_LOGO} alt="OhCampus" className="h-10 w-auto object-contain" /></div>
        <h2 className="font-heading text-xl font-extrabold text-[#312E81] text-center">Sign in</h2>
        <p className="text-xs text-slate-400 mt-1 mb-6 text-center flex items-center justify-center gap-1"><Lock className="w-3 h-3" /> Authorised staff only</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1 h-11" required />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1 h-11" required />
          </div>
          {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-11 bg-[#4F46E5] hover:bg-[#4338CA] text-white font-semibold">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
